import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe } from '../../../../shared/pipes/translate.pipe';

@Component({
  selector: 'app-sheet-format-delete-confirm-modal',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './sheet-format-delete-confirm-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './sheet-format-delete-confirm-modal.component.css',
})
export class SheetFormatDeleteConfirmModalComponent {
  @Input() formatName = '';
}
